const orderEntryProductFields = [
  'code',
  'commercialCode',
  'images(FULL)',
  'faqs(faqEntries(code))',
  'instructionsForUse',
  'name',
  'url',
  'externalLogistician',
  'familyAnneeN',
  'family2',
  'productGenre'
];

const orderEntryFields = [
  'basePrice(formattedValue)',
  `product(${orderEntryProductFields.join(',')})`,
  'totalPrice(formattedValue,value)',
  'totalPriceWithoutDiscounts(formattedValue,value)',
  'entryGroupNumbers',
  'quantity'
];

const consignmentFields = [
  'bill(url)',
  'code',
  `entries(orderEntry(${orderEntryFields.join(
    ','
  )}),shippedQuantity,consignedEntryShippedTotal,shippedTotalWithoutDiscount )`,
  'returnable',
  'status',
  'statusDate',
  'trackingID',
  'trackingURL'
];

const promotionFields = [
  'promotion(FULL)',
  'promotionActions(amount(formattedValue, value),usedCouponCodes,usedCouponNames)',
  'consumedEntries(orderEntryNumber)',
  'description'
];

export const orderDetailsFields = [
  'entryGroups(FULL,entries(FULL))',
  'code',
  `consignments(${consignmentFields.join(',')})`,
  'created',
  'deliveryAddress(addressName,firstName,lastName,pickupID, postalCode, town, email, country, streetName, streetNumber)',
  'deliveryMode(deliveryDuration, description, code, type, name)',
  'net',
  'paymentAddress(addressName,firstName,lastName,pickupID, postalCode, town, email, country, streetName, streetNumber)',
  'paymentModeDetail(FULL)',
  'status',
  'totalPrice(currencyIso, formattedValue, value)',
  `unconsignedEntries(${orderEntryFields.join(',')})`,
  'subTotalPriceWithProductDiscounts(formattedValue, value)',
  'deliveryCost',
  'totalDiscountsWithoutDeliveryCost(formattedValue, value)',
  'totalEcoTax(formattedValue, value)',
  'totalTax(formattedValue, value)',
  `appliedOrderPromotions(${promotionFields.join(',')})`,
  `appliedProductPromotions(${promotionFields.join(',')})`,
  'user(name,uid,encryptedEmail)',
  'isForfait',
  'serviceShippingIncluded',
  'saveOrderProducts',
  'bill(url)',
  'voucherFileForService(url)',
  'gsebPaymentInfo(FULL)',
  'depositWithdrawalAddress(FULL)',
  'voucherFileForService',
  'customerTransportLabel',
  'aspTransportLabel',
  'urlTrackingForCustomerTransport',
  'urlTrackingForAspTransport',
  'cartId',
  'paymentCost(formattedValue, value)',
  'selectedPaymentMode',
  'totalProducts',
  'relayPointAddress(FULL)',
  'extendedWarrantyOrder(FULL)',
  'guid',
  'orderType'
];
